module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURUdwTG9vb3BwcGxsbG9vb25ubm5ubm9vb3BwcLe3t0GDXZgAAAAJdFJOUwD6jx3XPEqra7dvKckAAABRSURBVBjTY5iJChgmMCADTjrxzQ1Q+YHOqHxWEQNU/VAFcD5UAcJ8iAIEH6IAyf7CBhQ+kxCqekUFFD5EGsGHSMP5UGk4P1EBlc9Gt/BEi08AC9Yn33htjTcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/casePage/turn-page-right.png
// module id = iPhg
// module chunks = 0